import { SignupDetailsRequestUserTypeEnum } from "@src/shared/api/generated"

export const enum USER_TYPES {
  MERCHANT = "merchant",
  REFERRER = "referrer",
}

export const USER_TYPES_OPTIONS = [
  { label: "Merchant", value: SignupDetailsRequestUserTypeEnum.Merchant },
  { label: "Referrer", value: SignupDetailsRequestUserTypeEnum.Referrer },
]

export const enum REGISTRATION_STEPS {
  AUTH,
  SELF_INFO,
}

export const CONTACTS_OPTIONS = [
  "phone",
  "email",
  "whatsapp",
  "telegram",
  "line",
]
